import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants/api';
import { decodeToken, getToken, removeToken } from '../../utils/TokenUtils';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const Check2FA = () => {
  const [qrCode, setQrCode] = useState('');
  const [userToken, setUserToken] = useState('');
  const [verificationMessage, setVerificationMessage] = useState('');
  const token = getToken();
  const navigate = useNavigate(); // Hook to navigate to other routes
  const [rememberDevice, setRememberDevice] = useState(false);
  // console.log('token:', token);
  const companyName = decodeToken(token, 'companyName');
  const companyLogo = decodeToken(token, 'logo');
  const [deviceFingerprint, setDeviceFingerprint] = useState(null);

  useEffect(() => {
    // Initialize FingerprintJS and get the device fingerprint
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceFingerprint(result.visitorId); // unique identifier for this device
    };

    loadFingerprint();
  }, []);
  // Function to handle the 2FA token verification
  const handleVerify2FA = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/api/users/verify-2fa`,
        {
          userToken,
          rememberDevice,
          deviceFingerprint,
        },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );
      // console.log('response:', response.data);
      if (response.data.success === 1) {
        // If login is successful, the server will return a JWT token
        removeToken();
        const token = response.data.token;
        const is2FaVerified = decodeToken(token, 'is2FaVerified');
        if (rememberDevice && response.data.deviceToken) {
          localStorage.setItem('trusted_device', response.data.deviceToken);
        }
        // console.log('new token:', token, 'is2FaVerified:', is2FaVerified);
        // Store the JWT token in localStorage (or sessionStorage)
        localStorage.setItem('authToken', token);
        notification.success({ message: '2FA Verified successfully!' });
        navigate('/dashboard');
        setVerificationMessage('2FA Verified successfully!');
      } else {
        notification.error({ message: 'Invalid token!' });
      }
    } catch (error) {
      console.error('Error verifying 2FA:', error);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-md-6 p-4 border rounded shadow-lg bg-light">
        {/* Company Logo */}
        <div className="text-center mb-4">
          {companyLogo && (
            <img
              src={`${API_URL}/${companyLogo}`}
              alt="Company Logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100px',
                objectFit: 'contain',
              }}
            />
          )}
        </div>

        <h2 className="text-center mb-4">{companyName}</h2>
        <h2 className="text-center mb-4">Authenticator 2FA</h2>

        {/* <button onClick={handleGenerate2FA}>Generate 2FA QR Code</button> */}

        <div className="text-center">
          <form onSubmit={handleVerify2FA}>
            <div className="input-group">
              <input
                type="text"
                autoFocus
                placeholder="Enter token  Authenticator"
                value={userToken}
                onChange={(e) => setUserToken(e.target.value)}
                width={'100%'}
                className="form-control"
              />
              <button className="btn btn-primary" type="submit">
                Verify 2FA
              </button>
            </div>

            <div className="d-flex justify-content-end align-items-center">
              <label className="form-check-label fs-4">
                <input
                  type="checkbox"
                  checked={rememberDevice}
                  onChange={(e) => setRememberDevice(e.target.checked)}
                  className="form-check-input form-check-lg"
                />
                <label> Remember & Trust this device</label>
              </label>
            </div>
          </form>
        </div>

        {verificationMessage && <p>{verificationMessage}</p>}
      </div>
    </div>
  );
};

export default Check2FA;
